import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { trending } from "@/mocks/trending";
import { formatHeat } from "@/utils/content";

export default function RankingSection() {
  const maxHeat = Math.max(...trending.map((item) => item.heat));

  return (
    <section id="ranking" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="热门话题榜"
            title="这个假期，被讨论最多的十个话题"
            desc="热度值根据公开讨论量与话题持续时间综合估算，仅用于呈现相对排序，不代表任何事实判断。"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-x-10 gap-y-0 md:grid-cols-2">
          {trending.map((item, index) => (
            <Reveal key={item.rank} delay={index * 30}>
              <div className="flex items-center gap-4 border-b border-background-200 py-4">
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                    index < 3 ? "bg-primary-600 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="truncate text-sm font-medium text-foreground-950">{item.title}</span>
                    <span className="shrink-0 rounded-sm bg-accent-100 px-1.5 py-0.5 text-[10px] font-bold text-accent-800">
                      {item.tag}
                    </span>
                  </div>
                  <div className="mt-2 flex items-center gap-3">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-primary-400"
                        style={{ width: `${(item.heat / maxHeat) * 100}%` }}
                      />
                    </div>
                    <span className="w-14 shrink-0 text-right text-xs text-foreground-500">
                      {formatHeat(item.heat)}
                    </span>
                  </div>
                </div>
                <span className="hidden shrink-0 text-xs text-foreground-400 lg:block">{item.category}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}